import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-payment-type',
  templateUrl: './dialog-payment-type.component.html',
  styleUrls: ['./dialog-payment-type.component.scss'],
})
export class DialogPaymentTypeComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
